import Image from "next/image";
import Link from "next/link";
import { Spinner } from "react-bootstrap";
import styled from "styled-components";

import AANavDropdown from "./AANavDropdown";
import { useState } from "react";

type WhoAmI = {
  user: {
    email: string;
    avatar_url: string | null;
  };
};

const AvatarDropdown = styled(AANavDropdown)`
  .dropdown-toggle {
    padding: 0;
  }
  .dropdown-toggle::after {
    display: none;
  }
`;

const AvatarImage = styled(Image)<{ $variant: "light" | "dark" }>`
  border: 1px solid;
  border-radius: 50%;
  ${({ $variant }) =>
    $variant === "light"
      ? `border-color: var(--aa-yellow);`
      : `border-color: var(--aa-light-black);`}
`;

const AvatarNoImage = styled.span<{ $variant: "light" | "dark" }>`
  ${({ $variant }) =>
    $variant === "light"
      ? `color: var(--aa-yellow);`
      : `color: var(--aa-light-black);`}
  font-size: 28px;
  line-height: 28px;
`;

function AvatarPopover({
  whoami,
  onLogOut,
  variant = "light",
  accountManagementHref,
}: {
  whoami: WhoAmI;
  onLogOut: () => void;
  variant?: "light" | "dark";
  accountManagementHref?: string;
}) {
  const [isLoggingOut, setIsLoggingOut] = useState<boolean>(false);

  const handleSignOut = () => {
    setIsLoggingOut(true);
    onLogOut();
  };

  const avatar = whoami.user.avatar_url ? (
    <AvatarImage
      $variant={variant}
      src={whoami.user.avatar_url}
      alt=""
      width={28}
      height={28}
      unoptimized={true}
      referrerPolicy="no-referrer"
    />
  ) : (
    <AvatarNoImage $variant={variant} className="bi-person-circle" />
  );

  return (
    <AvatarDropdown title={avatar} align="end" id="avatar-dropdown">
      <AANavDropdown.Header>{whoami.user.email}</AANavDropdown.Header>
      {accountManagementHref && (
        <AANavDropdown.Item as={Link} href={accountManagementHref}>
          <i className="bi-person-gear me-2" />
          Account Management
        </AANavDropdown.Item>
      )}
      <AANavDropdown.Divider />
      <AANavDropdown.Item
        as="button"
        disabled={isLoggingOut}
        onClick={handleSignOut}
      >
        {isLoggingOut ? (
          <Spinner size="sm" />
        ) : (
          <>
            <i className="bi-box-arrow-right me-2" />
            Sign Out
          </>
        )}
      </AANavDropdown.Item>
    </AvatarDropdown>
  );
}

export default AvatarPopover;
